import { isMockMode, postBlast, simulateDelay } from "../../api";

export const updateNodeLibrary = ({
	id,
	name,
	isVisibleToOrg,
	isWritableByOrg,
}: {
	id: string;
	name?: string;
	isVisibleToOrg?: boolean;
	isWritableByOrg?: boolean;
}) => {
	if (isMockMode()) {
		const testData = {
			success: true,
		};
		return simulateDelay(50, () => testData);
	}

	return postBlast(`nodelibrary/update`, {
		id,
		name,
		isVisibleToOrg,
		isWritableByOrg,
	});
};
